import React, { Component } from 'react'
import styled from 'styled-components'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import media from 'styled-media-query'
import planet from '../../../images/planet.svg'
import mobileplanet from '../../../images/mobileplanet.svg'
import noop from '../../../utils/noop'

const SlideWrapper = styled.div`
  padding: ${(props) => (props.i === 0 ? '0 12px 0 0' : '0 12px')};
  ${media.lessThan('600px')`
 padding: ${(props) => (props.i === 0 ? '0 8px 0 0' : '0 8px')};

 `}
`

const VirtualTourButtonDesktop = styled.a`
  .desktop {
    ${media.lessThan('large')`
    display: none;
  `}
  }
  .mobile {
    ${media.greaterThan('medium')`
    display: none;
  `}
  }
  justify-content: center;
  text-decoration: none;
  .left {
    margin-right: 16px;
    ${media.lessThan('medium')`
    margin-right: 8px;

    `}
  }
  .title {
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 140%;
    display: flex;
    align-items: center;
    text-align: center;
    color: #31279b;
    ${media.lessThan('medium')`
    font-size: 18px;

    `}
  }
  .desc {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #677d95;
  }
  padding: 20px 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  height: 74px;
  width: 234px;
  max-width: 234px;
  border: 1px solid #31279b;
  border-radius: 6px;
  margin-left: auto;
  ${media.lessThan('medium')`
  margin-right: 16px;
  max-width: none;
  width: auto;
  height: 52px;
  `}
`

const Style = styled.div`
  .slick-track {
    width: max-content !important;
  }
  ${media.lessThan('medium')`
padding-left: ${(props) => (props.padding ? '16px' : '0px')};
`}
  .slider-image {
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
    ${media.lessThan('1277px')`
    max-width: 764px;
    width: 7644px;

    `}
    ${media.lessThan('1099px')`
    max-width: 764px;
    width: 764px;
    height: 480px;

    `}
    ${media.lessThan('1028px')`
    max-width: 764px;
    width: 764px;
    height: 480px;

    `}
    ${media.lessThan('880px')`
    max-width: 764px;
    width: 764px;
    height: 480px;

    `}
    ${media.lessThan('800px')`
    max-width: 80vw;
    width: 80vw;
    height: 400px;

    `}
    ${media.lessThan('768px')`
    max-width: 80vw;
    width: 80vw;
    height: 400px;

    `}
    ${media.lessThan('500px')`
    max-width: 80vw;
    width: 80vw;
    height: 224px;

    `}
    max-width: 764px;
    width: 764px;
    height: 480px;
    overflow: hidden;
    border-radius: 16px;
  }
  max-width: 1369px;
  margin: 56px auto 26px !important;
  ${media.lessThan('medium')`
  margin: 78px auto 0px !important;
  `}
  .caption {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 140%;
    color: #394e66;
    margin: 16px 0 0 0;
  }
  .slide2 {
    margin-top: 31px;
    display: flex;
    width: 100%;
    padding-right: 16px;
    justify-content: ${(props) => (props.mobile ? 'center' : 'start')};
  }
  .section1 {
    width: ${(props) => (props.virtualTour ? 'calc(100% - 254px)' : '100%')};
    ${media.lessThan('medium')`
    display: none;
    `}
  }
  .section2 {
    width: 363px;
    ${media.lessThan('medium')`
    max-width: 88vw;
    width: 100%;
    height: 52px;
    `}
  }
`

let widths = [1400, 500]

export default class Sliders extends Component {
  constructor(props) {
    super(props)
    this.state = {
      nav1: null,
      nav2: null,
      activeSlide: 0,
      infinite: false
    }
  }
  componentDidMount() {
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2
    })
  }

  render() {
    return (
      <Style
        virtualTour={this.props.virtualTour}
        padding={this.props.padding}
      >
        <div>
          <Slider
            asNavFor={this.state.nav2}
            ref={(slider) => (this.slider1 = slider)}
            swipeToSlide={false}
            focusOnSelect={false}
            className="variable-width"
            variableWidth={true}
            infinite={false}
            centerMode={false}
            dots={false}
            arrows={true}
            edgeFriction={true}
            slidesToScroll={1}
            slidesToShow={1}
            slidesPerRow={1}
            responsive={[
              {
                breakpoint: 768,
                settings: {
                  infinite: false
                }
              }
            ]}
            beforeChange={(current, newindex) => {
              this.setState({ ...this.state, activeSlide: newindex })
              if (newindex === 0) {
                this.setState({
                  ...this.state,
                  activeSlide: newindex
                })
              }
              if (current === 0) {
                this.setState({
                  ...this.state,
                  activeSlide: newindex
                })
              }
            }}
            nextArrow={
              <RightArrow
                slideLength={this.props.slides.length}
                activeSlide={this.state.activeSlide}
              />
            }
            prevArrow={
              <LeftArrow
                slideLength={this.props.slides.length}
                activeSlide={this.state.activeSlide}
              />
            }
          >
            {this.props.slides?.map((slide, i) => {
              const srcSet = widths
                .map(
                  (width) =>
                    `${slide.replace(
                      'upload/',
                      `upload/c_lfill,q_90,f_auto,h_800,w_${width}/`
                    )} ${width}w`
                )
                .join(', ')
              return (
                <div key={i}>
                  <SlideWrapper i={i}>
                    <div
                      style={{}}
                      className="slider-image"
                    >
                      <img
                        style={{
                          height: '100%',
                          width: '100%',
                          objectFit: 'cover'
                        }}
                        srcSet={srcSet}
                      />
                    </div>
                  </SlideWrapper>
                </div>
              )
            })}
          </Slider>
          {false && (
            <h4 className="caption">
              Our breathtaking campus gives individuals the space to open up
              about their addiction.
            </h4>
          )}
          <div className="slide2">
            <div className="section1">
              <Slider
                key={4132}
                asNavFor={this.state.nav1}
                ref={(slider) => {
                  return (this.slider2 = slider)
                }}
                afterChange={noop}
                slidesToShow={
                  this.props.slides?.length <= 6
                    ? this.props.slides.length
                    : this.props.virtualTour
                    ? 6
                    : 8
                }
                slidesPerRow={1}
                responsive={[
                  {
                    breakpoint: 1379,
                    settings: {
                      slidesToShow:
                        this.props.slides?.length <= 6
                          ? this.props.slides.length
                          : this.props.virtualTour
                          ? 6
                          : 7
                    }
                  },
                  {
                    breakpoint: 1289,
                    settings: {
                      slidesToShow:
                        this.props.slides?.length <= 5
                          ? this.props.slides.length
                          : this.props.virtualTour
                          ? 5
                          : 6
                    }
                  },
                  {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow:
                        this.props.slides?.length <= 4
                          ? this.props.slides.length
                          : this.props.virtualTour
                          ? 4
                          : 5
                    }
                  },
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow:
                        this.props.slides?.length <= 4
                          ? this.props.slides.length
                          : this.props.virtualTour
                          ? 4
                          : 5
                    }
                  },
                  {
                    breakpoint: 966,
                    settings: {
                      slidesToShow:
                        this.props.slides?.length <= 3
                          ? this.props.slides.length
                          : this.props.virtualTour
                          ? 3
                          : 4
                    }
                  },
                  {
                    breakpoint: 790,
                    settings: {
                      slidesToShow:
                        this.props.slides?.length <= 2
                          ? this.props.slides.length
                          : this.props.virtualTour
                          ? 2
                          : 3
                    }
                  }
                ]}
                swipeToSlide={true}
                focusOnSelect={true}
                className="variable-width"
                variableWidth={true}
                infinite={this.state.infinite}
                centerMode={false}
                dots={false}
                arrows={false}
                slidesToScroll={1}
                edgeFriction={true}
              >
                {this.props.slides?.map((slide, i) => (
                  <div key={slide}>
                    <div
                      style={{
                        padding: i === 0 ? '0 10px 0 0' : '0 10px',
                        opacity: i !== this.state.activeSlide ? '0.5' : '1',
                        marginTop: i === this.state.activeSlide ? '0px' : '2px'
                      }}
                    >
                      <div
                        style={{
                          width:
                            i === this.state.activeSlide ? '150px' : '145px',
                          height:
                            i === this.state.activeSlide ? '80px' : '75px',
                          overflow: 'hidden',
                          borderRadius:
                            i === this.state.activeSlide ? '10px' : '8px',
                          border:
                            i === this.state.activeSlide
                              ? '1px solid black'
                              : 'none',
                          padding: i === this.state.activeSlide ? '4px' : '0px',
                          margin: 'auto',
                          cursor: 'pointer'
                        }}
                      >
                        <img
                          src={slide.replace(
                            'upload/',
                            'upload/c_lfill,q_30,f_webp,h_800,w_1400/'
                          )}
                          style={{
                            height: '100%',
                            width: '100%',
                            objectFit: 'cover',
                            borderRadius: '8px'
                          }}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
            {this.props.virtualTour && (
              <div className="section2">
                <VirtualTourButtonDesktop
                  style={{ marginTop: '2px' }}
                  href={`#${this.props.virtualTourElementId}`}
                  onClick={() => {
                    window.dataLayer.push({ ecommerce: null })
                    window.dataLayer.push({
                      event: 'purchase',
                      ecommerce: {
                        items: [
                          {
                            item_name: this.props.data.title,
                            item_id: this.props.data.slug,
                            item_variant: this.props.data.listing_template,
                            item_category: 'Profile Intro Virtual Tour Button'
                          }
                        ]
                      }
                    })
                  }}
                >
                  <div className="left">
                    <img
                      style={{ height: '22px', width: '22px' }}
                      src={planet}
                      className="desktop"
                    />
                    <img
                      style={{ height: '16px', width: '16px' }}
                      src={mobileplanet}
                      className="mobile"
                    />
                  </div>
                  <div className="right">
                    <p className="title">See Virtual Tour</p>
                  </div>
                </VirtualTourButtonDesktop>
              </div>
            )}
          </div>
        </div>
      </Style>
    )
  }
}

const RightArrowDiv = styled.div`
  ${media.lessThan('medium')`
    display: none !important;

  `}
  .boundary {
    border-radius: 100%;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 3px 4px 12px rgba(0, 0, 0, 0.55);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 60px;
    width: 60px;
    :hover {
      background: #ccccff;
    }
  }
`
const RightArrow = (props) => {
  const { onClick, activeSlide, slideLength } = props
  return (
    <RightArrowDiv
      style={{
        position: 'absolute',
        top: '50%',
        right: '16px',
        cursor: 'pointer',
        display: activeSlide === slideLength - 1 ? 'none' : 'block'
      }}
    >
      <div
        className="boundary"
        onClick={onClick}
      >
        <svg
          width="15"
          height="24"
          viewBox="0 0 15 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.49824 3.84867L9.54762 11.898L1.49824 19.9474C0.78767 20.6831 0.797832 21.8526 1.52108 22.5758C2.24433 23.2991 3.41378 23.3092 4.14949 22.5987L13.5245 13.2237C14.2565 12.4915 14.2565 11.3046 13.5245 10.5724L4.14949 1.19742C3.67873 0.709999 2.9816 0.514519 2.32604 0.686111C1.67049 0.857702 1.15853 1.36966 0.986936 2.02522C0.815344 2.68077 1.01082 3.3779 1.49824 3.84867Z"
            fill="#162941"
          />
        </svg>
      </div>
    </RightArrowDiv>
  )
}

const LeftArrowDiv = styled.div`
  ${media.lessThan('medium')`
    display: none !important;

  `}
  .boundary {
    border-radius: 100%;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 3px 4px 12px rgba(0, 0, 0, 0.55);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 60px;
    width: 60px;
    :hover {
      background: #ccccff;
    }
  }
  z-index: 999;
  transform: rotate(180deg);
`
const LeftArrow = (props) => {
  const { onClick, activeSlide } = props
  return (
    <LeftArrowDiv
      style={{
        position: 'absolute',
        top: '50%',
        left: '16px',
        cursor: 'pointer',
        display: activeSlide === 0 ? 'none' : 'block'
      }}
    >
      <div
        className="boundary"
        onClick={onClick}
      >
        <svg
          width="15"
          height="24"
          viewBox="0 0 15 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.49824 3.84867L9.54762 11.898L1.49824 19.9474C0.78767 20.6831 0.797832 21.8526 1.52108 22.5758C2.24433 23.2991 3.41378 23.3092 4.14949 22.5987L13.5245 13.2237C14.2565 12.4915 14.2565 11.3046 13.5245 10.5724L4.14949 1.19742C3.67873 0.709999 2.9816 0.514519 2.32604 0.686111C1.67049 0.857702 1.15853 1.36966 0.986936 2.02522C0.815344 2.68077 1.01082 3.3779 1.49824 3.84867Z"
            fill="#162941"
          />
        </svg>
      </div>
    </LeftArrowDiv>
  )
}
